import type { ReactNode } from 'react';

interface ReviewSplitProps {
  /** The rendered picture: a slide strip, or the square of a generated single. */
  picture: ReactNode;
  /** The decision: status heading, caption, actions, findings, budget. */
  children: ReactNode;
}

/**
 * The review screen's two columns for a run that rendered something. Once the
 * content area is 640px wide the picture sits left (a square as tall as the
 * window leaves) and the decision panel sits right, `position: sticky` and no
 * taller than the picture's room, so Approve never scrolls away from the
 * picture it approves. Narrower, the panel follows the picture.
 */
export function ReviewSplit({ picture, children }: ReviewSplitProps) {
  return (
    <div className="review-split">
      <div className="review-split__picture">{picture}</div>
      <div className="review-split__panel">{children}</div>
    </div>
  );
}
